<div *ngIf="isPublic">
  <app-insights-enablement [resourceId]="resourceId" [detectorId]="detectorId"></app-insights-enablement>
</div>
<div *ngIf="!isPublic">
    Inside <b> Diagnose and Solve</b> portal, the customer will see a link to enable and connection application insights.
</div>